export const KAHVE_AREN = [
  {
    id: "kar001",
    metin: "{{ad}}, bu fincanı görünce güldüm açıkçası! {{soru}} diye soruyorsun ya — fincan tam da bunu gösteriyor ama bambaşka bir şekilde! Kahvenin dibindeki o şekil biliyor musun neye benziyor? Tam bir soru işaretine! Evren de senin kadar kararsız görünüyor bu konuda.\n\nAma şunu söyleyeyim: yakında her şey netleşecek. Ve o netleşme anında 'vay be, bu kadar basitmiş' diyeceksin. Bazen cevaplar sorulardan çok daha basit olur — sadece görmeyi bilmek lazım.",
    tema: "netlesme"
  },
  {
    id: "kar002",
    metin: "{{ad}}, dur dur dur! Bu fincan çok konuşuyor bugün. {{soru}} konusunda kafan karışık biliyorum — ama fincan diyor ki: aslında cevabı çoktan biliyorsun, sadece kabullenmek istemiyorsun!\n\nBazen en zor şey doğruyu kendimize itiraf etmektir. O itirafı yap. İçinden geçen o ilk his — genellikle doğrudur. Ona kulak ver, bastırma.",
    tema: "itiraf"
  },
  {
    id: "kar003",
    metin: "{{ad}}, fincanına bakarken kahkaha atmak istedim! Neden mi? Çünkü tam ortada bir kalp var, ama baş aşağı! {{soru}} konusunda da duygular biraz ters dönmüş gibi.\n\nYa sevdiğini sandığın şeyi aslında sevmiyorsun, ya da sevmediğini sandığını aslında seviyorsun! Bu karmaşadan korku duyma — kafan karışık olduğunda genellikle bir dönüşümün eşiğindesin. O dönüşüme izin ver.",
    tema: "duygular"
  },
  {
    id: "kar004",
    metin: "{{ad}}, bu fincan sana bağırıyor neredeyse! {{soru}} için beklediğin haber geliyor — ama hazır mısın ona?\n\nFincan bana şunu söylüyor: haberi bekliyorsun ama geldiğinde ne yapacağını bilmiyorsun. Hadi biraz hazırlık yap. Sürprizlere gülümsemeyi öğren — hayat en güzel şeyleri hazırlıksız anlara saklıyor.",
    tema: "haber"
  },
  {
    id: "kar005",
    metin: "{{ad}}, fincanını çevirince ilk gördüğüm şey bir dans figürü! Dans mı ediyorsun hayatla yoksa hayat mı seninle dans ediyor? {{soru}} konusunda da biraz dans gerekiyor.\n\nBazen öne bazen geri, ama ritmi kaybetme. Dans etmeden ritmi öğrenemezsin. Müzik durmadıkça dans devam eder — ve müzik henüz durmadı.",
    tema: "ritim"
  },
  {
    id: "kar006",
    metin: "{{ad}}, fincanın içine bak! {{soru}} diye soruyorsun ama fincan başka bir soru soruyor sana: 'Gerçekten istediğin bu mu?'\n\nHani bazen insan bir şeyi çok ister, alır, sonra 'ee?' der ya — işte o an yaklaşıyor. Ama merak etme, o 'ee?' anından sonra gerçek istek ortaya çıkar. Ve gerçek isteğin peşinden gitmek, çok daha güzel.",
    tema: "istek"
  },
  {
    id: "kar007",
    metin: "{{ad}}, fincanına baktım ve içimden 'bu kişi çok düşünüyor' dedim! {{soru}} konusunda beynin çalışırken kalbin bekliyor, kalbin konuşurken beyin bağırıyor!\n\nBu kavgayı kim kazanacak? İkisi de kazanacak — sadece zamanlaması önemli. Önce kalp, sonra beyin. Hisset, sonra düşün. Bu sırayı dene — farklı sonuçlar göreceksin.",
    tema: "kalp_beyin"
  },
  {
    id: "kar008",
    metin: "{{ad}}, bu fincan bana şaka yapıyor gibi! {{soru}} için baktım, tam cevap verecektim ki kahve tam ortadan ikiye bölünmüş!\n\nBu ne demek biliyor musun? İki farklı yol, iki farklı ihtimal. Ve ikisi de seni farklı ama güzel yerlere götürür. Hangisi daha doğru sana sorarsan — hangisi daha çok heyecan veriyorsa, o.",
    tema: "iki_yol"
  },
  {
    id: "kar009",
    metin: "{{ad}}, fincanında bir sürpriz saklı! {{soru}} konusunda en beklemediğin yerden bir gelişme olacak.\n\nFincan bana şunu fısıldıyor: 'O an geldiğinde ağzı açık kalacak!' Hazır ol, sürprizlere gülümsemeyi öğren. En güzel dönemler çoğunlukla planlanmamış anlarda başlar.",
    tema: "surpriz"
  },
  {
    id: "kar010",
    metin: "{{ad}}, fincanın kenarında ilginç bir şekil var — sanki küçük bir insan koşuyor! {{soru}} konusunda sen de koşar gibi davranıyorsun ama nereye koştuğunu bilmiyorsun!\n\nDur, nefes al, yönüne bak. Sonra koş — ama doğru yöne. Hız değil, yön önemli. Yanlış yönde koşmak seni daha hızlı kayba götürür.",
    tema: "yon"
  },
  {
    id: "kar011",
    metin: "{{ad}}, fincan bana bir sır veriyor bugün. {{soru}} ile ilgili etrafında birisi bir şey biliyor ama söylemiyor.\n\nZamanı gelince o sır kendiliğinden ortaya çıkacak — ve şaşıracaksın. O ana kadar merakını sabırla yönet. Her sır bir gün konuşur.",
    tema: "sir"
  },
  {
    id: "kar012",
    metin: "{{ad}}, bu fincan komik bir enerji taşıyor! {{soru}} konusunda ciddi ciddi kara kara düşünürken, hayat sana gülüyor olabilir.\n\nGülümsemeyi unutma — çünkü fincan bana şunu söylüyor: en çok güldüğün anda en önemli şey gerçekleşecek. Ağırlığı bir kenara bırak, hafifle. Hafif olan daha hızlı ilerler.",
    tema: "gulumse"
  },
  {
    id: "kar013",
    metin: "{{ad}}, fincanında bir hazine işareti var! {{soru}} konusunda aramadığın yerde bir hazine var — maddi değil, duygusal.\n\nBelki bir ilişki, belki bir fırsat, belki bir keşif. Gözünü aç, hazineyi kaçırma. Hazineler her zaman beklenmedik yerlerde durur.",
    tema: "hazine"
  },
  {
    id: "kar014",
    metin: "{{ad}}, fincan bana şunu söylüyor: sen çok iyi bir aktörsün! {{soru}} konusunda iyi olduğunu göstermeye çalışıyorsun ama içinde farklı hissediyorsun.\n\nMaskeyi bir kenara bırak, gerçek hislerini göster. Gerçeklik her zaman performanstan daha etkileyicidir. Ve gerçek sen, maskenin arkasındaki senden çok daha ilginç.",
    tema: "gerceklik"
  },
  {
    id: "kar015",
    metin: "{{ad}}, fincanında dans eden noktalar var! {{soru}} için şunu söyleyeyim: hayat seninle dans etmek istiyor. Sen ama köşede oturuyorsun!\n\nPiste çık, dans et, hata yap, düzelt, yeniden dene. Dans etmeden ritmi öğrenemezsin. Mükemmel olmasına gerek yok — sadece başla.",
    tema: "dans"
  },
  {
    id: "kar016",
    metin: "{{ad}}, fincan bana müjde veriyor! {{soru}} konusunda beklediğin şey geliyor — ama tam aramayı bırakırken!\n\nBu evrenin klasik şakası. Aramayı bırak, bırakınca bulursun. Bu saçma mı geliyor? Dene bakalım. Odağını farklı bir yere ver — ve izle ne oluyor.",
    tema: "mujde"
  },
  {
    id: "kar017",
    metin: "{{ad}}, fincanının ortasında güneş şeklinde bir leke var! {{soru}} konusunda karanlık dönem bitiyor, aydınlık geliyor.\n\nAma bu aydınlık dışarıdan değil içeriden gelecek — kendi güneşin olacaksın. Başkalarının onayına ihtiyaç duymadan parlayan türden bir ışık. O ışık zaten var içinde.",
    tema: "aydinlik"
  },
  {
    id: "kar018",
    metin: "{{ad}}, fincan bugün çok konuşkan! {{soru}} ile ilgili şunu söylüyor: etrafındaki insanlar seni olduğundan farklı görüyor — hem iyi hem kötü yönde.\n\nGerçek sen ortada bir yerde. O gerçek seni daha çok göster. Ne çok iyi görünmeye çalış ne de olduğundan kötü. Sadece gerçek ol — en ikna edici o.",
    tema: "algi"
  },
  {
    id: "kar019",
    metin: "{{ad}}, fincanında bir köpek şekli seçiyorum — sadakat, dostluk, bağlılık. {{soru}} konusunda sadık bir dosta ihtiyacın var ya da sen birine sadık bir dost olmak üzeresin.\n\nBu enerji çok güzel — besle onu. Gerçek dostluklar nadir bulunur, bulununca da özenle korunur.",
    tema: "dostluk"
  },
  {
    id: "kar020",
    metin: "{{ad}}, fincan bana bugün çok eğlenceli bir şey gösteriyor. {{soru}} konusunda aşırı ciddiye aldığın bir şey var.\n\nBiraz gevşe, biraz gül. Hayatın bazı soruları gülümseyerek çözülür — kaşları çatarak değil. Bugün o soruya gülümseyerek bak. Perspektif değişince her şey değişir.",
    tema: "hafiflik"
  },
  {
    id: "kar021",
    metin: "{{ad}}, fincanının dibinde bir tohum şekli var! {{soru}} konusunda ektiğin tohumlar filizlenmeye başlıyor — göremeyebilirsin henüz.\n\nAma toprak altında bir hareket var. Sulamaya devam et. Tohumdan ağaç olmak zaman ister — ama o ağaç mutlaka büyür.",
    tema: "filiz"
  },
  {
    id: "kar022",
    metin: "{{ad}}, fincan bana bir dedektif hikayesi anlatıyor! {{soru}} konusunda gizem var — bir şeyler tam göründüğü gibi değil.\n\nMeraklı ol, araştır, soru sor. Cevap beklenmedik bir ipucunda saklı. En iyi dedektifler sabırlı olanlardır — acele etme, ipuçlarını topla.",
    tema: "gizem"
  },
  {
    id: "kar023",
    metin: "{{ad}}, fincanında bir gökkuşağı enerjisi var — rengarenk, canlı! {{soru}} konusunda tek renge sıkışma.\n\nHayatın tüm renklerine açık ol. En güzel tablolar çok renkle yapılır. Monotonluk güvenli görünür ama büyümeyi durdurur. Renk katmaktan korkmayın.",
    tema: "renklilik"
  },
  {
    id: "kar024",
    metin: "{{ad}}, fincan bana şunu söylüyor: sen düşündüğünden çok daha eğlenceli bir insansın! {{soru}} konusunda kendini çok kısıtlıyorsun.\n\nBiraz beklenmedik davran. Hayat sürprizleri sevenlerle dans eder. Bugün alışkın olmadığın bir şey yap — küçük de olsa. Ne hissettirdiğini gör.",
    tema: "ozgurluk"
  },
  {
    id: "kar025",
    metin: "{{ad}}, fincan şunu fısıldıyor: hayat aslında bir oyun, ama kuralları sen yazıyorsun! {{soru}} konusunda da kendi kurallarını yaz.\n\nBaşkalarının oyununu oynama — kendi sahnenin yıldızı ol. Ve unutma, en iyi oyunlar gülerek oynanır. Bugün o oyuna gülümseyle başla.",
    tema: "oyun"
  }
];